import {makeStyles} from '@material-ui/core/styles';
import EncodeSansBold from '../../../../../assets/fonts/Encode_Sans/EncodeSans-Bold.ttf'
import EncodeSansRegular from '../../../../../assets/fonts/Encode_Sans/EncodeSans-Regular.ttf'
import PoppinsRegular from "../../../../../assets/fonts/Poppins/Poppins-Regular.ttf";
import PoppinsExtraBold from "../../../../../assets/fonts/Poppins/Poppins-ExtraBold.ttf";
import EncodeSansSemiBold from "../../../../../assets/fonts/Encode_Sans/EncodeSans-SemiBold.ttf";
import EncodeSansLight from "../../../../../assets/fonts/Encode_Sans/EncodeSans-Light.ttf";

export default makeStyles(theme => ({
    alert: {
        backgroundColor: theme.palette.warning.dark
    },
    buttonForm2: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#9A9A9A",
        marginLeft: "5px",
        marginRight: "5px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    listRow: {
        alignItems: 'center',
    },
    subtitleStyle: {
        fontFamily: 'Nunito',
        color: "rgba(187,13,102,0.7)",
        fontSize: "16px",
        marginBottom: "-16px"
    },
    loadingDiv: {
        position: "absolute",
        top: "50%",
        left: "50%",
    },
    modalTitle: {
        fontFamily: "EncodeSansRegular",
        fontSize: "20px",
        color: "#bb0d66",
        textAlign: "center"
    },
    modalColumn: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly"
    },
    btnShare: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "14px",
        background: "#BB0D66",
        padding: "10px 30px 10px 30px",
        margin: "10px 5px -10px 5px",
        textDecoration: "none",
        border: "solid #BB0D66 0px",
        fontFamily: EncodeSansLight,
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    coberturaFormTexts: {
        fontFamily: EncodeSansRegular,
        fontSize: "16px",
        fontWeight: "bold"
    },
    cotSuccTable: {
        border: "2px solid #000",
        overflow: "hidden",
        borderRadius: "30px"
    },
    cotSuccTitle: {
        fontFamily: EncodeSansRegular,
        fontSize: "22px"
    },
    cotSuccAuto: {
        fontFamily: PoppinsExtraBold,
        fontSize: "20px",
        color: "#bb0d66",
    },
    cotSuccValor: {
        fontFamily: EncodeSansRegular,
        fontSize: "18px"
    },
    buttonsCotSucc: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    buttonContainedCotSucc: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#BB0D66",
        marginTop: "20px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    buttonCotSucc: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    textContainerCotSucc: {
        backgroundColor: '#ffb25e',
        padding: theme.spacing(1),
        borderRadius: '10%',
        alignItems: 'center',
    },
    outStandardTextCotSucc: {
        align: 'center',
        fontSize: 10
    },
    iconCircle: {
        clipPath: "circle(25px at 50% 50%)",
        background: "#bb0d66",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "-50px",
        height: "50px"
    },
    formBox: {
        backgroundColor: "#fff",
        borderRadius: "20px",
        width: "800px",
        boxShadow: "5px 10px 18px #888888",
        padding: "30px"
    },
    text: {
        fontSize: "24px",
        marginTop: "32px",
        display: "flex",
        padding:"0 48px",
        flexDirection: "row",
        justifyContent: "center",
        textAlign:"center"
    },
    poppinsFont: {
        fontFamily: PoppinsRegular,
        color: "#000",
    },
    verDetalles: {
        fontFamily: EncodeSansSemiBold,
        marginLeft: "50px",
        color: "#bb0d66",
        fontSize: "12px",
    },
    radioCheck: {
        borderRadius: "50%",
        width: "30px",
        height: "30px",
        border: "1px solid #000000",
        transition: "0.2s all linear",
        marginRight: "16px",
        position: "relative",
        top: "16px",
        '&:checked': {
            border: "10px solid #bb0d66",
        },
    },
    inputTextArea: {
        width: "250px",
        height: "120px"
    },
    formTitles: {
        fontFamily: EncodeSansBold,
        color: "#2f2f2f",
        fontSize: "40px"
    },
    stepper: {
        padding: theme.spacing(3, 0, 5),
        iconColor: '#452d7b',
    },
    buttons: {
        display: 'flex',
        flexDirection: "row",
        justifyContent: 'center'
    },
    buttonContained: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#BB0D66",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "20px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    backButton: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#9A9A9A",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "20px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    },

    step: {
        "& $completed": {
            color: '#452d7b'
        },
        "& $active": {
            color: '#452d7b'
        },
    },
    alternativeLabel: {},
    active: {}, //needed so that the &$active tag works
    completed: {},
    labelContainer: {
        "& $alternativeLabel": {
            marginTop: 0
        }
    },
}));
